export default __webpack_public_path__ + "static/107997-32500de2647682edfde20f9d087c550d.jpg";